const { remUnit, designWidth } = require('../const-value')

const flexible = (doc, win) => {
    let docEl = doc.documentElement,
        resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
        reCalc = function () {
            let clientWidth = docEl.clientWidth;
            if (!clientWidth) return;
            const sUserAgent = navigator.userAgent.toLowerCase();
            if (
                /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent) ||
                clientWidth <= 375
            ) {
                docEl.style.fontSize = remUnit * (clientWidth / designWidth) + 'px';
            } else {
                docEl.style.fontSize = '16px';
            }
        };
    if (!doc.addEventListener) return;
    win.addEventListener(resizeEvt, reCalc, false);
    doc.addEventListener('DOMContentLoaded', reCalc, false);
}

flexible(document, window);
